export const language = {
	title: 'Professional Experience',
	toolsUsedHeader: 'Tools',
	skillsAcquiredTitle: 'Skill Acquired',
	technologiesUsedHeader: 'Tech',
	toolsAndTechHeader: 'Tools & Tech',
	languagesHeader: 'Languages',
};
